// extracted by mini-css-extract-plugin
export default {"redressInfo":"RedressInfoCheckbox_redressInfo__ioW2h","checkbox":"RedressInfoCheckbox_checkbox__dwEAw"};